export default function htmlEncode(str: string) {
    return (
        window!
            .document!.createElement('div')!
            .appendChild(window!.document!.createTextNode(str))!
            .parentNode as HTMLElement
    ).innerHTML;
}
